import { isPlatformServer } from '@angular/common';
import { DestroyRef, inject, Injectable, makeStateKey, PLATFORM_ID, signal, WritableSignal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TransferState } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { DealsRepository } from '@core/services/repositories/deals.repository';
import { Observable, tap } from 'rxjs';


const DEALS_KEY = makeStateKey<any[]>('deals-data');

@Injectable({
  providedIn: 'root'
})
export class DealsService {
  hotels: WritableSignal<any | null> = signal(null);
  private transferState = inject(TransferState);
  private platformId = inject(PLATFORM_ID);
  private destroyRef = inject(DestroyRef);
  private repo = inject(DealsRepository)
  private activatedRoute = inject(ActivatedRoute)

  constructor() { }

  getDealsData(code: string): Observable<any> | void {
    const cached = this.transferState.get(DEALS_KEY, null);
    
    const hotels$ = this.repo.getDealsHotels(code).pipe(
      tap((res) => {
        this.hotels.set(res);
        this.transferState.set(DEALS_KEY, res);
      })
    );

    if (isPlatformServer(this.platformId)) {
      return hotels$; // SSR → return می‌کنیم تا Angular صبر کنه
    } else {
      if (cached) {
        this.hotels.set(cached);
        this.transferState.remove(DEALS_KEY); // ⚠️ optional: prevent reuse later
      } else {
        hotels$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe();
      }
    }
  }
}
